import {useEffect, useState} from "react";
import Button from "./Button";
import CourseContent from "./CourseContent";
import SwitcherLessons from "./SwitcherLessons";
import data from "../data";
import SwitcherCourses from "./SwitcherCourses";

function LogoCard() {
    const [course, setCourse] = useState(data[0]);
    const [lesson, setLesson] = useState(course.lessons[0]);
    useEffect(() => { setLesson(course.lessons[0]); }, [course]);

    return (
        <div className="logo-card">
            <SwitcherCourses
                info={data}
                handler={setCourse}
                currentCourse={course}
            />
            <h1>Астрология для всех</h1>
            <div className="main-section">
                <h1>Астрология для всех</h1>
                <h5>Изучайте астрологию и понимайте себя глубже</h5>
                <CourseContent content={lesson}/>
                <Button text="Записаться на курс"/>
            </div>
            <SwitcherLessons
                course={course.lessons}
                handler={setLesson}
                activeLesson={lesson}
            />
        </div>
    )
}

export default LogoCard;